// 定义一些公共的属性和方法
const httpUrl = 'http://www.cywy56.com/'
const imageUrl = 'http://www.cywy56.com/files/'

const tradeTypeStr = val => {
  return val == '' ? '全部' : val == '101' ? '线上充值' : val == '102' ? '线下充值' : val == '103' ? '退款' : val == '104' ? '业务收入' : val == '105' ? '赠送' : val == '201' ? '直接支付' : val == '202' ? '余额支付' : val == '203' ? '赠送款支付' : val == '204' ? '余额提现' : '';
}
const tradeStatusStr = val => {
  return val === '' ? '全部' : val === 0 ? '处理中' : val == 1 ? '成功' : val == 2 ? '失败' : '';
}
const insuranceStatusStr = val => {
  return val === '' ? '全部' : val === 0 ? '投保中' : val == 1 ? '已投保' : val == 2 ? '失败' : val == 3 ? '失效' : '';
}
const signStatusStr = val => {
  return val == 0 || val == 1 || val == 2 ? '未签署' : val == 3 ? '签署中' : val == 4 || val == 5 ? '已签署' : '';
}
const tabMatchAmount = tab => {
  return tab == 0 ? '10' : tab == 1 ? '3000' : tab == 2 ? '5000' : tab == 3 ? '10000' : '';
}

const axios = {
  get: (e, url, data, callBack, errorCallBack) => {
    const loading = e.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    e.$axios.get(url, {
      params: data
    }).then(res => {
      loading.close();
      if (res.data.code == 200 || res.data.code == 0) {
        callBack(res.data);
      } else {
        if (errorCallBack) errorCallBack(res.data);
        if (res.data.code != 2) e.$message.error(res.data.errorMsg ? res.data.errorMsg : res.data.code);
      }
    })
  },
  post: (e, url, data, callBack, errorCallBack, completeCallBack) => {
    const loading = e.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    e.$axios.post(url, e.$qs.stringify(data)).then(res => {
      loading.close();
      if (res.data.code == 200 || res.data.code == 0) {
        callBack(res.data);
      } else {
        if (errorCallBack) errorCallBack(res.data);
        if (res.data.code != 2) e.$message.error(res.data.errorMsg ? res.data.errorMsg : res.data.code);
      }
      if (completeCallBack) completeCallBack(res.data);
    })
  },
  delete: (e, url, data, callBack) => {
    e.$axios.delete(url, {
      params: data
    }).then(res => {
      if (res.data.code == 200 || res.data.code == 0) {
        callBack(res.data);
      } else {
        e.$message.error(res.data.msg ? res.data.msg : res.data.code);
      }
    })
  }
}
function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
const format = (time, rule) => {
  if (time == null) return '';
	let date = new Date(time);
	var o = {
		"M+" : date.getMonth()+1,                 //月份
		"d+" : date.getDate(),                    //日
		"h+" : date.getHours(),                   //小时
		"m+" : date.getMinutes(),                 //分
		"s+" : date.getSeconds(),                 //秒
		"q+" : Math.floor((date.getMonth()+3)/3), //季度
		"S"  : date.getMilliseconds()             //毫秒
  };
	if(/(y+)/.test(rule))
		rule=rule.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
	for(var k in o)
		if(new RegExp("("+ k +")").test(rule))
	rule = rule.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
	return rule;
}
const uploadValid = (e, res) => {
  if (res.status == 'success') {
    if (res.response.errorCode == 0 || res.response.errorCode == 200) {
      //
    } else if (res.response.code == 2) {
      e.$message.error('状态已过期，请登录');
      e.$store.commit('loginChange', false);
      e.$router.push('/login');
    } else {
      e.$message.error(res.response.errorMsg);
    }
  }
}
const convertMultiple = (options) => {
  if (options.data.length > 1000) {
    let promiseArr = new Array(Math.ceil(options.data.length / 1000));

    for (let index = 0; index < promiseArr.length; index++) {
      promiseArr[index] = new Promise((resolve, reject) => {
        new AMap.convertFrom(options.data.slice(index * 1000, (index+1) * 1000), 'gps', (status, res) => {
          if (res.info === 'ok') {
            resolve(res.locations);
          }
        })
      })
    }
    Promise.all(promiseArr).then(res => {
      let arr = new Array();
      if (options.data.length > 1000) {
        res.forEach(ele => {
          ele.forEach(ele1 => {
            arr.push(ele1);
          })
        })
      } else {
        arr = res;
      }
      options.handle(arr);
    })
  } else {
    let p = new Promise((resolve, reject) => {
      new AMap.convertFrom(options.data, 'gps', (stauts, res) => {
        if (res.info === 'ok') {
          resolve(res.locations);
        }
      })
    })
    p.then(res => {
      options.handle(res);
    });
  }
}
const goPay = (e, option, callBack) => {
  e.$confirm('此次操作需要收取'+option.price+'元，是否继续？', {
    confirmButtonText: '继续',
    cancelButtonText: '取消',
    center: true
  }).then(() => {
    option.payType = 1;
    delete option.price;
    axios.post(e, '/sywl/api/pay/payment', option, res => {
      callBack(res);
    })
  }).catch(info => {})
}
const valueFromObj = (obj, key) => {
  if (obj[key]) {
    return obj[key];
  } else {
    let arr = key.split('.');
    return valueFromObj(obj[arr.splice(0, 1)], arr.join('.'));
  }
}
const export2Excel = (columns, list, excelName) => {
  require.ensure([], () => {
      const { export_json_to_excel } = require('@/excel/Export2Excel.js');
      let tHeader = []
      let filterVal = []
      columns.forEach(item =>{
          tHeader.push(item.title);
          filterVal.push(item.key);
      })
      const data = list.map(v => filterVal.map(j => { return valueFromObj(v, j); }))
      export_json_to_excel(tHeader, data, excelName);
  })
}

// 暴露出这些属性和方法
export default {
  tradeTypeStr,
  tradeStatusStr,
  insuranceStatusStr,
  signStatusStr,
  tabMatchAmount,
  httpUrl,
  imageUrl,
  axios,
  getUrlKey,
  format,
  uploadValid,
  convertMultiple,
  goPay,
  export2Excel
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js